import type { CSSProperties } from "react";

// MATERIAL SYMBOLS (ROUNDED, WEIGHT 300), THE SAME ICON FONT AND NAMES THE
// ANGULAR MENU USES - BUNDLED FROM THE `material-symbols` PACKAGE
export function Icon({ name, size = 24, style }: { name: string; size?: number; style?: CSSProperties }) {
  return (
    <span className="material-symbols-rounded" aria-hidden="true" style={{ fontSize: size, lineHeight: 1, ...style }}>
      {name}
    </span>
  );
}
